import { EventEmitter, Directive, Inject, PLATFORM_ID, ElementRef, Renderer2, Optional, Output, Input, Component, forwardRef, ViewEncapsulation, NgZone, ViewChild, Pipe, InjectionToken, NgModule } from '@angular/core';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { timer } from 'rxjs';
import { loadLazyJsFile, loadLazyCssFile, closestPolifill } from '@techmore/global';
import * as moment_ from 'moment';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/date-time-picker.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: datepicker
 */
class DateTimePickerDirective {
    /**
     * @param {?} platformId
     * @param {?} el
     * @param {?} render
     * @param {?} document
     * @param {?} assets
     */
    constructor(platformId, el, render, document, assets) {
        this.platformId = platformId;
        this.el = el;
        this.render = render;
        this.document = document;
        this.assets = assets;
        /**
         * 可以開始使用元件了
         */ 
        // tslint:disable-next-line: member-ordering
        this.canInit = false;
        /**
         * 指令初始化完成
         */ 
        // tslint:disable-next-line: member-ordering
        this.init = new EventEmitter();
        /**
         * Fired when the widget is hidden.
         */ 
        // tslint:disable-next-line: member-ordering
        this.dpHide = new EventEmitter();
        /**
         * Fired when the widget is shown.
         */ 
        // tslint:disable-next-line: member-ordering
        this.dpShow = new EventEmitter();
        /**
         * Fired when the date is changed, including when changed to a non-date (e.g. When keepInvalid=true).
         */ 
        // tslint:disable-next-line: member-ordering
        this.dpChange = new EventEmitter();
        /**
         * Fired when a selected date fails to pass validation.
         */ 
        // tslint:disable-next-line: member-ordering
        this.dpError = new EventEmitter();
        /**
         * Fired (in most cases) when the viewDate changes. E.g. Next and Previous buttons, selecting a year.
         */ 
        // tslint:disable-next-line: member-ordering
        this.dpUpdate = new EventEmitter();
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.isBrowser) {
            this.idName = '-dateFilter' + DateTimePickerDirective.compCount++;
        }
    }
    /**
     * 載入插件的方法
     * @param {?} document
     * @param {?} renderer
     * @param {?} parentEl
     * @param {?} isBrowser
     * @param {?} assetsConfig
     * @return {?}
     */
    static loadPlugin(document, renderer, parentEl, isBrowser, assetsConfig) {
        DateTimePickerDirective.isPluginIniting = true;
        checkIfDepLoad((/**
         * @return {?}
         */
        () => {
            assetsConfig.scripts.forEach((/**
             * @param {?} sc
             * @return {?}
             */
            sc => {
                /** @type {?} */
                const sca = sc.split('/');
                /** @type {?} */
                const scName = sca[sca.length - 1];
                loadLazyJsFile(document, renderer, scName, sc);
            }));
            assetsConfig.styles.forEach((/**
             * @param {?} st
             * @return {?}
             */
            st => {
                /** @type {?} */
                const sta = st.split('/');
                /** @type {?} */
                const stName = sta[sta.length - 1];
                loadLazyCssFile(document, renderer, parentEl, stName, st);
            }));
        }));
        checkPluginCanUse((/**
         * @return {?}
         */
        () => {
            DateTimePickerDirective.isPluginInit = true;
            DateTimePickerDirective.isPluginIniting = false;
            DateTimePickerDirective.pulginInit.emit();
            DateTimePickerDirective.pulginInit.complete();
        }));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.isBrowser) {
            if (!DateTimePickerDirective.isPluginInit) {
                DateTimePickerDirective.pulginInit.subscribe((/**
                 * @return {?}
                 */
                () => {
                    this.target = $(this.el.nativeElement);
                    this.initDatetimepicker();
                }));
            }
            else {
                this.target = $(this.el.nativeElement);
                this.initDatetimepicker();
            }
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            if (!DateTimePickerDirective.isPluginInit && !DateTimePickerDirective.isPluginIniting) {
                if (isPluginLoaded()) {
                    DateTimePickerDirective.isPluginInit = true;
                }
                else {
                    DateTimePickerDirective.loadPlugin(this.document, this.render, this.el.nativeElement, this.isBrowser, this.assets || dateTimePickerAssetsDefaultConfig);
                }
            }
            if (!DateTimePickerDirective.isPluginInit) {
                DateTimePickerDirective.pulginInit.subscribe((/**
                 * @return {?}
                 */
                () => {
                    this.canInit = true;
                }));
            }
            else {
                this.canInit = true;
            }
        }
    }
    /**
     * @private
     * @return {?}
     */
    initDatetimepicker() {
        this.target.datetimepicker(this.pickerBase.attr);
        if (this.pickerBase.attr.inline) {
            if (this.target.data('DateTimePicker').date()) {
                this.target.data('DateTimePicker').clear();
            }
        }
        this.canInit = true;
        this.init.emit();
        this.target.on('dp.hide', (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            this.dpHide.emit(e);
        }));
        this.target.on('dp.show', (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            this.dpShow.emit(e);
        }));
        this.target.on('dp.change', (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            this.dpChange.emit(e);
        }));
        this.target.on('dp.error', (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            this.dpError.emit(e);
        }));
        this.target.on('dp.update', (/**
         * @param {?} e
         * @return {?}
         */
        (e) => {
            this.dpUpdate.emit(e);
        }));
        this.setDateTimePickerId();
        this.setDateTimePickerHeaders();
    }
    /**
     * @return {?}
     */
    clear() {
        if (this.target) {
            this.target.data('DateTimePicker').clear();
        }
    }
    /**
     * @return {?}
     */
    getDate() {
        if (this.target) {
            return this.target.data('DateTimePicker').date() ? this.target.data('DateTimePicker').date().valueOf() : undefined;
        }
        else {
            return undefined;
        }
    }
    /**
     * @param {?} defaultDate
     * @return {?}
     */
    defaultDate(defaultDate) {
        if (this.target) {
            return this.target.data('DateTimePicker').defaultDate(defaultDate);
        }
        else {
            return undefined;
        }
    }
    /**
     * @param {?} date
     * @return {?}
     */
    setDate(date) {
        if (this.target) {
            this.target.data('DateTimePicker').date(date);
        }
    }
    /**
     * @param {?} date
     * @return {?}
     */
    setMinDate(date) {
        if (this.target) {
            /** @type {?} */
            const oriDate = this.getDate();
            this.target.data('DateTimePicker').minDate(date);
            if (this.getDate() !== oriDate) {
                this.target.data('DateTimePicker').clear();
            }
        }
    }
    /**
     * @return {?}
     */
    getMinDate() {
        if (this.target) {
            return this.target.data('DateTimePicker').minDate();
        }
        else {
            return undefined;
        }
    }
    /**
     * @param {?} date
     * @return {?}
     */
    setMaxDate(date) {
        if (this.target) {
            /** @type {?} */
            const oriDate = this.getDate();
            this.target.data('DateTimePicker').maxDate(date);
            if (this.getDate() !== oriDate) {
                this.target.data('DateTimePicker').clear();
            }
        }
        else {
            return undefined;
        }
    }
    /**
     * @return {?}
     */
    getMaxDate() {
        if (this.target) {
            return this.target.data('DateTimePicker').maxDate();
        }
        else {
            return undefined;
        }
    }
    /**
     * @param {?} disabledDates
     * @return {?}
     */
    setDisabledDates(disabledDates) {
        if (this.target) {
            this.target.data('DateTimePicker').disabledDates(disabledDates);
        }
        else {
            return undefined;
        }
    }
    /**
     * @return {?}
     */
    getDisabledDates() {
        if (this.target) {
            return this.target.data('DateTimePicker').disabledDates();
        }
        else {
            return undefined;
        }
    }
    /**
     * @param {?} markedDates
     * @return {?}
     */
    setMarkedDates(markedDates) {
        if (this.target) {
            this.target.data('DateTimePicker').markedDates(markedDates);
        }
        else {
            return undefined;
        }
    }
    /**
     * @return {?}
     */
    getMarkedDates() {
        if (this.target) {
            return this.target.data('DateTimePicker').markedDates();
        }
        else {
            return undefined;
        }
    }
    /** 無障礙thead th 要有對應id */
    /**
     * H105101 表格中超過二行/列以上的標題，須以結構化的標記確認彼此間的結構與關係
     * @return {?}
     */
    setDateTimePickerId() {
        this.target.find(".datepicker-days").find(".picker-switch").attr('id', 'datepicker-days' + this.idName);
        this.target.find(".datepicker-months").find(".picker-switch").attr('id', 'datepicker-months' + this.idName);
        this.target.find(".datepicker-years").find(".picker-switch").attr('id', 'datepicker-years' + this.idName);
        this.target.find(".datepicker-decades").find(".picker-switch").attr('id', 'datepicker-decades' + this.idName);
    }
    /**
     * 無障礙tbody td 要有對應headers
     * @return {?}
     */
    setDateTimePickerHeaders() {
        this.target.find(".datepicker-months").find("tbody td").attr('headers', 'datepicker-months' + this.idName);
        this.target.find(".datepicker-years").find("tbody td").attr('headers', 'datepicker-years' + this.idName);
        this.target.find(".datepicker-decades").find("tbody td").attr('headers', 'datepicker-decades' + this.idName);
    }
}
/**
 * 計算組件建立的次數，用來產生唯一的組件識別碼作為 dom id 用
 */ 
// tslint:disable-next-line: member-ordering
DateTimePickerDirective.compCount = 0;
/**
 * datetimepicker 插件初始化完成後觸發
 */
DateTimePickerDirective.pulginInit = new EventEmitter();
/**
 * 全域的 bootstrap-table 插件初始化完成
 */
DateTimePickerDirective.isPluginInit = false;
/**
 * 全域的 datetimepicker 插件在正初始化中
 */
DateTimePickerDirective.isPluginIniting = false;
DateTimePickerDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmDateTimePicker]'
            },] }
];
/** @nocollapse */
DateTimePickerDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DATE_TIME_PICKER_ASSETS,] }] }
];
DateTimePickerDirective.propDecorators = {
    init: [{ type: Output }],
    pickerBase: [{ type: Input }],
    dpHide: [{ type: Output }],
    dpShow: [{ type: Output }],
    dpChange: [{ type: Output }],
    dpError: [{ type: Output }],
    dpUpdate: [{ type: Output }]
};
if (false) {
    /**
     * 計算組件建立的次數，用來產生唯一的組件識別碼作為 dom id 用
     * @type {?}
     */
    DateTimePickerDirective.compCount;
    /**
     * datetimepicker 插件初始化完成後觸發
     * @type {?}
     */
    DateTimePickerDirective.pulginInit;
    /**
     * 全域的 bootstrap-table 插件初始化完成
     * @type {?}
     */
    DateTimePickerDirective.isPluginInit;
    /**
     * 全域的 datetimepicker 插件在正初始化中
     * @type {?}
     */
    DateTimePickerDirective.isPluginIniting;
    /**
     * 可以開始使用元件了
     * @type {?}
     */
    DateTimePickerDirective.prototype.canInit;
    /**
     * 指令初始化完成
     * @type {?}
     */
    DateTimePickerDirective.prototype.init;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    DateTimePickerDirective.prototype.isBrowser;
    /** @type {?} */
    DateTimePickerDirective.prototype.target;
    /**
     * 用於連結th td結構化
     * @type {?}
     */
    DateTimePickerDirective.prototype.idName;
    /**
     * [日曆參數](https://getdatepicker.com/4/Options/)
     * @type {?}
     */
    DateTimePickerDirective.prototype.pickerBase;
    /**
     * Fired when the widget is hidden.
     * @type {?}
     */
    DateTimePickerDirective.prototype.dpHide;
    /**
     * Fired when the widget is shown.
     * @type {?}
     */
    DateTimePickerDirective.prototype.dpShow;
    /**
     * Fired when the date is changed, including when changed to a non-date (e.g. When keepInvalid=true).
     * @type {?}
     */
    DateTimePickerDirective.prototype.dpChange;
    /**
     * Fired when a selected date fails to pass validation.
     * @type {?}
     */
    DateTimePickerDirective.prototype.dpError;
    /**
     * Fired (in most cases) when the viewDate changes. E.g. Next and Previous buttons, selecting a year.
     * @type {?}
     */
    DateTimePickerDirective.prototype.dpUpdate;
    /**
     * @type {?}
     * @protected
     */
    DateTimePickerDirective.prototype.platformId;
    /**
     * @type {?}
     * @protected
     */
    DateTimePickerDirective.prototype.el;
    /**
     * @type {?}
     * @protected
     */
    DateTimePickerDirective.prototype.render;
    /**
     * @type {?}
     * @protected
     */
    DateTimePickerDirective.prototype.document;
    /**
     * @type {?}
     * @protected
     */
    DateTimePickerDirective.prototype.assets;
}
/**
 * @return {?}
 */
function isPluginLoaded() {
    return jQuery.prototype.datetimepicker;
}
/** @type {?} */
const checkPluginCanUse = (/**
 * @param {?} cb
 * @return {?}
 */
(cb) => {
    /** @type {?} */
    const cpTmSubc = timer(0, 300).subscribe((/**
     * @param {?} t
     * @return {?}
     */
    t => {
        if (isPluginLoaded()) {
            cpTmSubc.unsubscribe();
            cb();
        }
    }));
});
const ɵ0 = checkPluginCanUse;
/**
 * @return {?}
 */
function isDepLoadeed() {
    return 'undefined' !== typeof window['jQuery'] && 'undefined' !== typeof window['moment'];
}
/**
 * @param {?} cb
 * @return {?}
 */
function checkIfDepLoad(cb) {
    /** @type {?} */
    const cdTmSubc = timer(0, 300).subscribe((/**
     * @param {?} t
     * @return {?}
     */
    t => {
        if (isDepLoadeed()) {
            cdTmSubc.unsubscribe();
            cb();
        }
    }));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/date-time-picker/date-time-picker.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const moment = moment_;
/**
 * 日期選擇器
 * 原名: techmore-picker
 */
class DateTimePickerComponent {
    /**
     * @param {?} platformId
     * @param {?} ngZone
     */
    constructor(platformId, ngZone) {
        this.platformId = platformId;
        this.ngZone = ngZone;
        this.date = '';
        /**
         * 文字輸入框的 placeholder
         */
        this.placeholder = '';
        /**
         * 是否禁用控件
         */
        this.disabled = false;
        /**
         * 日期選擇器參數設定
         */
        this._pickerSelector = {
            multiId: '',
            attr: {
                locale: 'zh-tw',
                format: 'YYYY/MM/DD HH:mm',
                useCurrent: true,
                defaultDate: ''
            }
        };
        this.showInlineInput = false;
        /**
         * 只有按鈕的日期選擇器，和 inline 同時使用該值無效
         */
        this.jumpPicker = false;
        /**
         * 按鈕樣式類名，和 inline 同時使用該值無效
         */
        this.addBtnClass = 'glyphicon glyphicon-calendar';
        /**
         * clear 事件從內部發出
         */
        this.clearFromInner = true;
        /**
         * 日期從組件外面被更新
         */
        this.isUpdateFromWhiteValue = false;
        /**
         * Fired when the widget is hidden.
         */ 
        // tslint:disable-next-line: member-ordering
        this.dpHide = new EventEmitter();
        /**
         * Fired when the widget is shown.
         */ 
        // tslint:disable-next-line: member-ordering
        this.dpShow = new EventEmitter();
        /**
         * Fired when the date is changed, including when changed to a non-date (e.g. When keepInvalid=true).
         */ 
        // tslint:disable-next-line: member-ordering
        this.dpChange = new EventEmitter();
        /**
         * Fired when a selected date fails to pass validation.
         */ 
        // tslint:disable-next-line: member-ordering
        this.dpError = new EventEmitter();
        /**
         * Fired (in most cases) when the viewDate changes. E.g. Next and Previous buttons, selecting a year.
         */ 
        // tslint:disable-next-line: member-ordering
        this.dpUpdate = new EventEmitter();
        this.propagateChange = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set selectedDate(val) {
        // const val = parseInt(value, 10);
        if (isNaN(val)) {
            if (this._selectedDate) {
                this._selectedDate = undefined;
                this.propagateChange(undefined);
                this.triggerDomChangeEvent();
                this.date = null;
                if (this.dtPicker.getDate()) {
                    this.dtPicker.clear();
                }
            }
        }
        else {
            this._selectedDate = val;
            this.propagateChange(val);
            this.triggerDomChangeEvent();
            this.date = moment(val).format(this.dateFormat);
        }
    }
    /**
     * @return {?}
     */
    get selectedDate() {
        return this._selectedDate;
    }
    /**
     * @param {?} date
     * @return {?}
     */
    set minDate(date) {
        if (this.dtPicker) {
            if (date && !isNaN(date)) {
                this.dtPicker.setMinDate(new Date(date));
            }
            else {
                this.dtPicker.setMinDate(false);
            }
            this._pendingMinDate = undefined;
        }
        else {
            this._pendingMinDate = date;
        }
    }
    /**
     * @return {?}
     */
    get minDate() {
        if (this.dtPicker) {
            return this.dtPicker.getMinDate();
        }
        return null;
    }
    /**
     * @param {?} date
     * @return {?}
     */
    set maxDate(date) {
        if (this.dtPicker) {
            if (date && !isNaN(date)) {
                this.dtPicker.setMaxDate(new Date(date));
            }
            else {
                this.dtPicker.setMaxDate(false);
            }
            this._pendingMaxDate = undefined;
        }
        else {
            this._pendingMaxDate = date;
        }
    }
    /**
     * @return {?}
     */
    get maxDate() {
        if (this.dtPicker) {
            return this.dtPicker.getMaxDate();
        }
        return null;
    }
    /**
     * @param {?} dates
     * @return {?}
     */
    set disabledDates(dates) {
        if (this.dtPicker) {
            if (dates && dates.length > 0) {
                this.dtPicker.setDisabledDates(dates);
            }
            else {
                this.dtPicker.setDisabledDates(false);
            }
            this._pendingDisabledDates = undefined;
        }
        else {
            this._pendingDisabledDates = dates;
        }
    }
    /**
     * @return {?}
     */
    get disabledDates() {
        if (this.dtPicker) {
            return this.dtPicker.getDisabledDates();
        }
        return null;
    }
    /**
     * 要做標記的日期
     * @param {?} dates
     * @return {?}
     */
    set markedDates(dates) {
        if (this.dtPicker) {
            if (dates && dates.length > 0) {
                this.dtPicker.setMarkedDates(dates);
            }
            else {
                this.dtPicker.setMarkedDates(false);
            }
            this._pendingMarkedDates = undefined;
        }
        else {
            this._pendingMarkedDates = dates;
        }
    }
    /**
     * 要做標記的日期
     * @return {?}
     */
    get markedDates() {
        if (this.dtPicker) {
            return this.dtPicker.getMarkedDates();
        }
        return null;
    }
    /**
     * @return {?}
     */
    get dateFormat() {
        if (this._pickerSelector.attr.format) {
            return this._pickerSelector.attr.format;
        }
        return 'YYYY/MM/DD HH:mm';
    }
    /**
     * @return {?}
     */
    get isInline() {
        if (this._pickerSelector.attr.inline) {
            return this._pickerSelector.attr.inline;
        }
        return false;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled ? true : false;
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        if (obj) {
            /** @type {?} */
            const val = parseInt(obj, 10);
            if (this.dtPicker.canInit) {
                /** @type {?} */
                const oriDate = this.dtPicker.getDate();
                if (!isNaN(val) && oriDate !== val) {
                    this.isUpdateFromWhiteValue = true;
                    this.dtPicker.setDate(new Date(val));
                    if (!this.dtPicker.getDate() || oriDate === val) {
                        if (this.selectedDate) {
                            this.selectedDate = undefined;
                        }
                        else {
                            this.propagateChange(undefined);
                        }
                    }
                }
            }
            else {
                this._pendingSelectedDate = val;
            }
        }
        else if (this.selectedDate) {
            // this.selectedDate = undefined;
            this.clearFromInner = false;
            this.dtPicker.clear();
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) { }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.pickerSelector) {
            this._pickerSelector.attr = Object.assign(this._pickerSelector.attr, this.pickerSelector.attr);
            // this._pickerSelector = Object.assign(this._pickerSelector, this.pickerSelector);
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.isBrowser) {
            if (this.dtPicker && this.dtPicker.canInit) {
                this.ngZone.run((/**
                 * @return {?}
                 */
                () => {
                    this.afterPickerInit();
                }));
            }
            if (this.dtPicker && !this.dtPicker.canInit) {
                this.dtPicker.init.subscribe((/**
                 * @param {?} v
                 * @return {?}
                 */
                v => {
                    this.afterPickerInit();
                }));
            }
        }
    }
    /**
     * @return {?}
     */
    afterPickerInit() {
        if (typeof this._pendingMinDate !== 'undefined') {
            this.minDate = this._pendingMinDate;
        }
        if (typeof this._pendingMaxDate !== 'undefined') {
            this.maxDate = this._pendingMaxDate;
        }
        if (typeof this._pendingDisabledDates !== 'undefined') {
            this.disabledDates = this._pendingDisabledDates;
        }
        if (typeof this._pendingMarkedDates !== 'undefined') {
            this.markedDates = this._pendingMarkedDates;
        }
        if (typeof this._pendingSelectedDate !== 'undefined') {
            /** @type {?} */
            const oriDate = this.dtPicker.getDate();
            if (!isNaN(this._pendingSelectedDate) && oriDate !== this._pendingSelectedDate) {
                this.isUpdateFromWhiteValue = true;
                this.dtPicker.setDate(new Date(this._pendingSelectedDate));
                if (!this.dtPicker.getDate() || oriDate === this._pendingSelectedDate) {
                    if (this.selectedDate) {
                        this.selectedDate = undefined;
                    }
                    else {
                        this.propagateChange(undefined);
                    }
                }
            }
        }
    }
    /**
     * 日期選擇器被點選了某日期
     * @param {?} e
     * @return {?}
     */
    updatePickTime(e) {
        /** @type {?} */
        let nowDate = (/** @type {?} */ (((/** @type {?} */ (e))).date));
        if (nowDate && nowDate instanceof moment) {
            /** @type {?} */
            const dateStr = nowDate.format(this.dateFormat);
            nowDate = moment(dateStr, this.dateFormat);
            if (this.isUpdateFromWhiteValue) {
                this.isUpdateFromWhiteValue = false;
                this._selectedDate = nowDate.valueOf();
                this.propagateChange(nowDate.valueOf());
                this.triggerDomChangeEvent();
                this.date = dateStr;
            }
            else {
                // 使用者點選導致的改變
                this.selectedDate = nowDate.valueOf();
            }
        }
        else if (((/** @type {?} */ (e))).oldDate) {
            // clear 導致的改變
            if (this._selectedDate) {
                this._selectedDate = undefined;
                this.date = null;
                if (!this.clearFromInner) {
                    this.clearFromInner = true;
                    this.propagateChange(undefined);
                    this.triggerDomChangeEvent();
                }
            }
        }
    }
    /**
     * 手動輸入日期
     * @param {?} evt
     * @return {?}
     */
    updateValue(evt) {
        /** @type {?} */
        const el = (/** @type {?} */ (evt.target));
        if (!el.value && this.selectedDate) {
            // this.selectedDate = '';
            this.clearFromInner = false;
            this.dtPicker.clear();
        }
        if (this.isInline) {
            this.dtPicker.setDate(new Date(el.value));
        }
    }
    /**
     * @param {?} el
     * @return {?}
     */
    onKeyDown(el) {
        // const subc = fromEvent(el, 'keyup').subscribe(evt => {
        //   subc.unsubscribe();
        //   if (!el.value && this.clearFromInner) {
        //     this.propagateChange(undefined);
        //     this.triggerDomChangeEvent();
        //   }
        // });
    }
    /**
     * @param {?} el
     * @return {?}
     */
    onInputBlur(el) {
        if (!el.value && this.clearFromInner) {
            this.propagateChange(undefined);
            this.triggerDomChangeEvent();
        }
    }
    /**
     * 點選日期後要手動觸發原生change事件
     * @return {?}
     */
    triggerDomChangeEvent() {
        /** @type {?} */
        let event;
        if (typeof (Event) === 'function') {
            event = new Event('change', { bubbles: true, cancelable: true });
        }
        else {
            event = document.createEvent('Event');
            event.initEvent('change', true, true);
        }
        this.dtPicker.target[0].dispatchEvent(event);
    }
}
DateTimePickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-date-time-picker',
                template: "<ng-container *ngIf=\"!isInline\">\r\n  <div tmDateTimePicker class='input-group date' [class.deny]=\"disabled\" [class.jump-picker]=\"jumpPicker\"\r\n  [pickerBase]=\"_pickerSelector\"\r\n  (dpHide)=\"dpHide.emit($event)\"\r\n  (dpShow)=\"dpShow.emit($event)\"\r\n  (dpChange)=\"dpChange.emit($event); updatePickTime($event)\"\r\n  (dpError)=\"dpError.emit($event)\"\r\n  (dpUpdate)=\"dpUpdate.emit($event)\">\r\n    <input type='text' [id]=\"name\" class=\"form-control\" (change)=\"updateValue($event)\" (keydown.Delete)=\"onKeyDown(dateInput)\" (blur)=\"onInputBlur(dateInput)\" [disabled]=\"disabled\" [value]=\"date\" attr.placeholder=\"{{placeholder}}\" #dateInput/>\r\n    <span class=\"input-group-addon\">\r\n      <span class=\"{{addBtnClass}}\"></span>\r\n    </span>\r\n  </div>\r\n</ng-container>\r\n<ng-container *ngIf=\"isInline\">\r\n  <input *ngIf=\"showInlineInput\" type='text' [id]=\"name\" class=\"form-control\" (change)=\"updateValue($event)\" (keydown.Delete)=\"onKeyDown(dateInput)\" (blur)=\"onInputBlur(dateInput)\" [disabled]=\"disabled\" [value]=\"date\" attr.placeholder=\"{{placeholder}}\" #dateInput/>\r\n  <div class='input-group date' [class.deny]=\"disabled\"\r\n  tmDateTimePicker\r\n  [pickerBase]=\"_pickerSelector\"\r\n  (dpHide)=\"dpHide.emit($event)\"\r\n  (dpShow)=\"dpShow.emit($event)\"\r\n  (dpChange)=\"dpChange.emit($event); updatePickTime($event)\"\r\n  (dpError)=\"dpError.emit($event)\"\r\n  (dpUpdate)=\"dpUpdate.emit($event)\"\r\n  ></div>\r\n</ng-container>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => DateTimePickerComponent)),
                        multi: true
                    }
                ],
                encapsulation: ViewEncapsulation.None,
                styles: [".input-group.date.deny[tmDateTimePicker]{position:relative;cursor:not-allowed}.input-group.date.deny[tmDateTimePicker] .input-group-addon{pointer-events:none}.input-group.date.deny[tmDateTimePicker] .bootstrap-datetimepicker-widget::after{content:\"\";display:block;position:absolute;width:100%;height:100%;background-color:#dfdfdf;top:0;left:0;opacity:.7;cursor:not-allowed;border-top-color:transparent;border-bottom-color:transparent}.input-group.date.jump-picker input.form-control{display:none}.input-group.date.jump-picker .input-group-addon{border-left:1px solid #ccc;border-right:1px solid #ccc;border-top-left-radius:4px;border-bottom-left-radius:4px;width:100%}"]
            }] }
];
/** @nocollapse */
DateTimePickerComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: NgZone }
];
DateTimePickerComponent.propDecorators = {
    name: [{ type: Input }],
    placeholder: [{ type: Input }],
    disabled: [{ type: Input }],
    pickerSelector: [{ type: Input }],
    minDate: [{ type: Input }],
    maxDate: [{ type: Input }],
    disabledDates: [{ type: Input }],
    markedDates: [{ type: Input }],
    showInlineInput: [{ type: Input }],
    jumpPicker: [{ type: Input }],
    addBtnClass: [{ type: Input }],
    dtPicker: [{ type: ViewChild, args: [DateTimePickerDirective, { static: false },] }],
    dpHide: [{ type: Output }],
    dpShow: [{ type: Output }],
    dpChange: [{ type: Output }],
    dpError: [{ type: Output }],
    dpUpdate: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    DateTimePickerComponent.prototype.date;
    /** @type {?} */
    DateTimePickerComponent.prototype._pendingSelectedDate;
    /** @type {?} */
    DateTimePickerComponent.prototype._selectedDate;
    /**
     * 控件名
     * @type {?}
     */
    DateTimePickerComponent.prototype.name;
    /**
     * 文字輸入框的 placeholder
     * @type {?}
     */
    DateTimePickerComponent.prototype.placeholder;
    /**
     * 是否禁用控件
     * @type {?}
     */
    DateTimePickerComponent.prototype.disabled;
    /**
     * 日期選擇器參數設定
     * @type {?}
     */
    DateTimePickerComponent.prototype._pickerSelector;
    /** @type {?} */
    DateTimePickerComponent.prototype.pickerSelector;
    /** @type {?} */
    DateTimePickerComponent.prototype._pendingMinDate;
    /** @type {?} */
    DateTimePickerComponent.prototype._pendingMaxDate;
    /** @type {?} */
    DateTimePickerComponent.prototype._pendingDisabledDates;
    /** @type {?} */
    DateTimePickerComponent.prototype._pendingMarkedDates;
    /** @type {?} */
    DateTimePickerComponent.prototype.showInlineInput;
    /**
     * 只有按鈕的日期選擇器，和 inline 同時使用該值無效
     * @type {?}
     */
    DateTimePickerComponent.prototype.jumpPicker;
    /**
     * 按鈕樣式類名，和 inline 同時使用該值無效
     * @type {?}
     */
    DateTimePickerComponent.prototype.addBtnClass;
    /**
     * 日期選擇器
     * @type {?}
     */
    DateTimePickerComponent.prototype.dtPicker;
    /**
     * 是否渲染端為瀏覽器
     * @type {?}
     * @protected
     */
    DateTimePickerComponent.prototype.isBrowser;
    /**
     * clear 事件從內部發出
     * @type {?}
     */
    DateTimePickerComponent.prototype.clearFromInner;
    /**
     * 日期從組件外面被更新
     * @type {?}
     */
    DateTimePickerComponent.prototype.isUpdateFromWhiteValue;
    /**
     * Fired when the widget is hidden.
     * @type {?}
     */
    DateTimePickerComponent.prototype.dpHide;
    /**
     * Fired when the widget is shown.
     * @type {?}
     */
    DateTimePickerComponent.prototype.dpShow;
    /**
     * Fired when the date is changed, including when changed to a non-date (e.g. When keepInvalid=true).
     * @type {?}
     */
    DateTimePickerComponent.prototype.dpChange;
    /**
     * Fired when a selected date fails to pass validation.
     * @type {?}
     */
    DateTimePickerComponent.prototype.dpError;
    /**
     * Fired (in most cases) when the viewDate changes. E.g. Next and Previous buttons, selecting a year.
     * @type {?}
     */
    DateTimePickerComponent.prototype.dpUpdate;
    /** @type {?} */
    DateTimePickerComponent.prototype.propagateChange;
    /**
     * @type {?}
     * @protected
     */
    DateTimePickerComponent.prototype.platformId;
    /**
     * @type {?}
     * @protected
     */
    DateTimePickerComponent.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipe/date-format.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const moment$1 = moment_;
class DateFormatPipe {
    /**
     * @param {?} date
     * @param {?} format
     * @return {?}
     */
    transform(date, format) {
        if (!date) {
            return;
        }
        if (format) {
            return moment$1(date).format(format);
        }
        else {
            return moment$1(date).format('YYYY/MM/DD');
        }
    }
}
DateFormatPipe.decorators = [
    { type: Pipe, args: [{
                name: 'DateFomat'
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/date-time-range-picker/date-time-range-picker.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DateTimeRangePickerComponent {
    constructor() {
        /**
         * 輸入框的placeholder
         */
        this.placeholder = '';
        this.disabled = false;
        this.disabledDates = null;
        this.separator = ' - ';
        this.addBtnClass = 'glyphicon glyphicon-calendar';
        this._pickerSelector = {
            multiId: '',
            attr: {
                inline: true,
                sideBySide: true,
            }
        };
        this.propagateChange = (/**
         * @param {?} _
         * @return {?}
         */
        (_) => { });
        this.isFieldEnabled = (/**
         * @param {?} granularity
         * @param {?} format
         * @return {?}
         */
        (granularity, format) => {
            if (typeof granularity !== 'string' || granularity.length > 1) {
                throw new TypeError('isEnabled expects a single character string parameter');
            }
            switch (granularity) {
                case 'y':
                    return format.indexOf('Y') !== -1;
                case 'M':
                    return format.indexOf('M') !== -1;
                case 'd':
                    return format.toLowerCase().indexOf('d') !== -1;
                case 'h':
                case 'H':
                    return format.toLowerCase().indexOf('h') !== -1;
                case 'm':
                    return format.indexOf('m') !== -1;
                case 's':
                    return format.indexOf('s') !== -1;
                default:
                    return false;
            }
        });
        this.hasTime = (/**
         * @param {?} format
         * @return {?}
         */
        (format) => {
            return (this.isFieldEnabled('h', format) || this.isFieldEnabled('m', format) || this.isFieldEnabled('s', format));
        });
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set startDate(value) {
        if (isNaN(value) && this._startDate) {
            this._startDate = undefined;
        }
        else {
            this._startDate = value;
        }
        this.propagateChange({ startDate: this.startDate, endDate: this.endDate });
    }
    /**
     * @return {?}
     */
    get startDate() { return this._startDate; }
    /**
     * @param {?} value
     * @return {?}
     */
    set endDate(value) {
        if (isNaN(value) && this._endDate) {
            this._endDate = undefined;
        }
        else {
            this._endDate = value;
        }
        this.propagateChange({ startDate: this.startDate, endDate: this.endDate });
    }
    /**
     * @return {?}
     */
    get endDate() { return this._endDate; }
    /**
     * @return {?}
     */
    get dateFormat() {
        if (this._pickerSelector.attr.format) {
            return this._pickerSelector.attr.format;
        }
        return 'YYYY/MM/DD HH:mm';
    }
    /**
     * @return {?}
     */
    get isTime() {
        if (this.dateFormat) {
            return this.hasTime(this.dateFormat);
        }
        return true;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.pickerSelector) {
            this._pickerSelector.attr = Object.assign(this.pickerSelector.attr, (/** @type {?} */ ({ inline: true, sideBySide: true })));
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    writeValue(obj) {
        if (obj) {
            this.startDate = obj.startDate;
            this.endDate = obj.endDate;
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
DateTimeRangePickerComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-date-time-range-picker',
                template: "<div class=\"input-group\">\r\n  <input type=\"text\" [disabled]=\"disabled\" class=\"form-control\" [value]=\"separator | dateRangeDisplay:isTime: startDate : endDate\" attr.placeholder=\"{{placeholder}}\">\r\n  <span id=\"dLabel\" class=\"input-group-addon\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n    <span class=\"{{addBtnClass}}\"></span>\r\n  </span>\r\n  <div class=\"dropdown-menu\" aria-labelledby=\"dLabel\">\r\n    <div class=\"datepicker-group\">\r\n      <tm-date-time-picker [disabled]=\"disabled\" [pickerSelector]=\"_pickerSelector\"\r\n        name=\"startDate\" [(ngModel)]=\"startDate\" [disabledDates]=\"disabledDates\"\r\n        [minDate]=\"rangeMinDate\" [maxDate]=\"endDate\" #startDp>\r\n      </tm-date-time-picker>\r\n      <tm-date-time-picker [disabled]=\"disabled\" [pickerSelector]=\"_pickerSelector\"\r\n        name=\"endDate\" [(ngModel)]=\"endDate\" [disabledDates]=\"disabledDates\"\r\n        [minDate]=\"startDate\" [maxDate]=\"rangeMaxDate\" #endDp>\r\n      </tm-date-time-picker>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => DateTimeRangePickerComponent)),
                        multi: true
                    }
                ],
                styles: [".datepicker-group{display:flex;flex-flow:row nowrap}"]
            }] }
];
/** @nocollapse */
DateTimeRangePickerComponent.ctorParameters = () => [];
DateTimeRangePickerComponent.propDecorators = {
    startDatePicker: [{ type: ViewChild, args: ['startDp', { static: false },] }],
    endDatePicker: [{ type: ViewChild, args: ['endDp', { static: false },] }],
    placeholder: [{ type: Input }],
    disabled: [{ type: Input }],
    rangeMinDate: [{ type: Input }],
    rangeMaxDate: [{ type: Input }],
    disabledDates: [{ type: Input }],
    separator: [{ type: Input }],
    addBtnClass: [{ type: Input }],
    pickerSelector: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.startDatePicker;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.endDatePicker;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype._startDate;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype._endDate;
    /**
     * 輸入框的placeholder
     * @type {?}
     */
    DateTimeRangePickerComponent.prototype.placeholder;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.disabled;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.rangeMinDate;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.rangeMaxDate;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.disabledDates;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.separator;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.addBtnClass;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.pickerSelector;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype._pickerSelector;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.propagateChange;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.isFieldEnabled;
    /** @type {?} */
    DateTimeRangePickerComponent.prototype.hasTime;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipe/date-range-display.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const moment$2 = moment_;
class DateRangeDisplayPipe {
    /**
     * @param {?} separator
     * @param {?=} isContainTime
     * @param {?=} startDate
     * @param {?=} endDate
     * @return {?}
     */
    transform(separator, isContainTime = false, startDate = null, endDate = null) {
        /** @type {?} */
        const format = isContainTime ? 'YYYY/MM/DD HH:mm' : 'YYYY/MM/DD';
        /** @type {?} */
        const startDateString = !startDate ? format : moment$2(startDate).format(format);
        /** @type {?} */
        const endDateString = !endDate ? format : moment$2(endDate).format(format);
        /** @type {?} */
        const displayString = (!!startDate || !!endDate) ? `${startDateString}${separator}${endDateString}` : null;
        return displayString;
    }
}
DateRangeDisplayPipe.decorators = [
    { type: Pipe, args: [{
                name: 'dateRangeDisplay'
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/date-time-picker.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const DATE_TIME_PICKER_ASSETS = new InjectionToken('DATE_TIME_PICKER_ASSETS');
/** @type {?} */
const dateTimePickerAssetsDefaultConfig = {
    scripts: ['bootstrap-datetimepicker.min.js'],
    styles: ['css/bootstrap-datetimepicker.min.css']
};
/**
 * [Bootstrap 3 Datepicker](https://getdatepicker.com/4/)的功能包裝模組，
 *  腳本和樣式檔是調整過的不是官方原版。
 * 在引用套件的模組提供 FROALA_ASSETS 這個依賴項目可以覆寫掉預設的資產載入配置
 * ```typescript
 * {provide: DATE_TIME_PICKER_ASSETS, useValue: {
 *   scripts: ['bootstrap-datetimepicker.min.js'],
 *   styles:  ['css/bootstrap-datetimepicker.min.css']
 * }}
 * ```
 */
class DateTimePickerModule {
    /**
     * @param {?} platformId
     */
    constructor(platformId) {
        this.platformId = platformId;
        if (isPlatformBrowser(this.platformId)) {
            if (!window['moment'] && moment_) {
                // tslint:disable-next-line: no-string-literal
                window['moment'] = moment_;
            }
        }
        closestPolifill();
    }
}
DateTimePickerModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    DateTimePickerComponent,
                    DateTimePickerDirective,
                    DateFormatPipe,
                    DateTimeRangePickerComponent,
                    DateRangeDisplayPipe,
                ],
                exports: [
                    DateTimePickerComponent,
                    DateFormatPipe,
                    DateTimeRangePickerComponent,
                ],
                imports: [
                    CommonModule,
                    FormsModule
                ]
            },] }
];
/** @nocollapse */
DateTimePickerModule.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    DateTimePickerModule.prototype.platformId;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: techmore-date-time-picker.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DATE_TIME_PICKER_ASSETS, DateFormatPipe, DateRangeDisplayPipe, DateTimePickerComponent, DateTimePickerDirective, DateTimePickerModule, DateTimeRangePickerComponent, dateTimePickerAssetsDefaultConfig };
//# sourceMappingURL=techmore-date-time-picker.js.map
